'use client';

import Image from 'next/image';
import classes from './FullScreenImage.module.scss';
import { Box } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';

type FullscreenImageProps = {
  src: string;
  alt: string;
  title: string;
  subtitle: string;
  name: string;
  subtitle2: string;
};

const FullscreenImage = ({ data }: { data: FullscreenImageProps }) => {
  const { src, alt, title, subtitle, name, subtitle2 } = data;
  useAOS();

  return (
    <>
      <div className={classes.padding} />
      <Box className={classes.box}>
        <Image src={src} alt={alt} fill className={classes.background} style={{ objectFit: "cover" }} />
        <div className={classes.content} data-aos="zoom-in">
          <div className={classes.name} data-aos="fade-up">
            {name}
          </div>
          <h1 className={classes.title} data-aos="fade-up">
            {title}
          </h1>
          <h2 className={classes.subtitle} data-aos="fade-up">
            {subtitle}
          </h2>
          <h3 className={classes.subtitle} data-aos="fade-up">
            {subtitle2}
          </h3>
        </div>
      </Box>
    </>
  );
};

export default FullscreenImage;
